import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ListGroup,
  Button,
  Modal,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import CandidateSearchBar from "../CandidateSearchBar/CandidateSearchBar";
import { createProject } from "../../Slices/orgAdminSlice";
import { useDispatch } from "react-redux";
import { showModal, showSpinner } from "../../Slices/sessionSlice";
import SpinnerButton from "../SpinnerButton/SpinnerButton";
import { newAlert } from "../../Slices/alertSlice";
export const id = "CREATE_PROJECT";
const saveProjectId = "createProject.save";

function CreateProject({ data }) {
  const dispatch = useDispatch();

  const [candidates, setCandidates] = useState([]);
  const [projectName, setProjectName] = useState("");
  // const { clientId } = data;
  console.log(candidates, "candidates");
  const saveProject = () => {
    if (projectName === "") {
      dispatch(
        newAlert({
          type: "danger",
          message: "Please Fill Project Name",
        })
      );
      return;
    }
    dispatch(showSpinner({ id: saveProjectId }));
    dispatch();
  };
  const addCandidate = (candidateToBeAdded) => {
    console.log(candidateToBeAdded[0], "candidate");
    if (candidateToBeAdded.length > 0) {
      let isValidCandidate = true;
      candidates.forEach((candidate) => {
        if (candidate._id === candidateToBeAdded[0]._id) {
          isValidCandidate = false;
        }
      });
      if (isValidCandidate) {
        setCandidates([...candidates, candidateToBeAdded[0]]);
      }
    }
  };
  return (
    <Modal
      show={true}
      centered
      onHide={() => {
        dispatch(showModal(null));
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Create Project </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <InputGroup className="mb-3">
            <InputGroup.Text id="edit-project-name">
              ProjectName
            </InputGroup.Text>
            <FormControl
              id="basic-url"
              aria-describedby="basic-addon3"
              onChange={(e) => setProjectName(e.target.value)}
              placeholder={"Enter Project Name"}
            />
          </InputGroup>
          <Card>
            <Card.Body>
              <Card.Title>List of Candidates</Card.Title>
              <ListGroup>
                {candidates &&
                  candidates.map((item) => (
                    <ListGroup.Item key={String(Math.random())}>
                      <Container>
                        <Row xs="">
                          <Col xs={10}>
                            {item.firstName} {item.lastName}
                          </Col>
                          <Col xs={2}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="red"
                              className="bi bi-trash"
                              viewBox="0 0 16 16"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setCandidates(
                                  candidates.filter(
                                    (candidate) => item._id !== candidate._id
                                  )
                                );
                              }}
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                              <path
                                fillRule="evenodd"
                                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                              />
                            </svg>
                          </Col>
                        </Row>
                      </Container>
                    </ListGroup.Item>
                  ))}
              </ListGroup>
            </Card.Body>
            <Card.Footer>
              <Container>
                <Row>
                  <Col>
                    <CandidateSearchBar
                      defaultSelected={null}
                      multiple={false}
                      handleSelection={addCandidate}
                    />
                  </Col>
                </Row>
              </Container>
            </Card.Footer>
          </Card>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-danger"
          onClick={() => {
            dispatch(showModal(null));
          }}
        >
          Cancel
        </Button>
        <SpinnerButton
          variant="outline-primary"
          id={saveProjectId}
          onClick={saveProject}
          name="Save"
        />
      </Modal.Footer>
    </Modal>
  );
}

export default CreateProject;
